<vs-select
  vsInput
  class="min-w-[200px]"
  [value]="value"
  [compareWith]="comparePolicies"
  [config]="{ multiple: true, placeholder: placeholder }"
  (valueChanges)="selectValueChanged($event)"
>
  <li *ngFor="let policy of policies$ | async" vs-select-option [value]="policy">
    <div class="flex flex-col">
      <span>{{ policy.title }}</span>
      <span class="text-xs text-gray-400">{{ policy.policyNumber }}</span>
    </div>
  </li>
</vs-select>
